import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { cn } from "@util/helpers";

type InputErrorProps = {
  /** The error to be displayed. */
  error: string;
  /** The class name to apply to the component. */
  className?: string;
};

/**
 * Component to display the error message for an input.
 */
const InputError = ({ error, className }: InputErrorProps) => {
  return (
    <div
      className={cn(
        "flex w-full items-center gap-2 pt-1 font-poppins text-xs tracking-2 text-red",
        className
      )}
      data-testid="input-error-component"
    >
      <IconFactory type={IconTypeEnum.error} x={13} y={12} size={16} />

      <p className={"mb-0 "}>{error}</p>
    </div>
  );
};

export default InputError;
